<template>
    <div class="api-info">
        <div class="api-info-item">
            <span>{{apiData.id}}</span>
        </div>
        <div class="api-info-item">
            <span>{{apiData.name}}</span>
        </div>
        <div class="api-info-item">
            <apiChart :apiId="apiData.id"></apiChart>
        </div>
        <div class="api-info-item">
            <span>{{apiData.bourse_name}}</span>
        </div>
        <div class="api-info-item">
            <span v-if="!initStatus">{{apiData.status_info}}</span>
            <span v-else style="color: #fff"><i class="el-icon-loading"></i></span>
        </div>
        <div class="api-info-item" style="font-size: 12px">
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="deleteApi(apiData.id)">删除</el-dropdown-item>
                    <el-dropdown-item @click.native="showConfig(apiData.id)">手续费配置</el-dropdown-item>
                    <el-dropdown-item @click.native="showBaseConfig(apiData.id)">基本配置</el-dropdown-item>
                    <el-dropdown-item @click.native="fleshCurve(apiData.id)">刷新收益曲线</el-dropdown-item>
                    <el-dropdown-item @click.native="advanceSetting(apiData.id)">API高级设置</el-dropdown-item>
                    <el-dropdown-item @click.native="initAsset(apiData.id)">配置初始化</el-dropdown-item>
                    <el-dropdown-item @click.native="showAssetTemplate(apiData.id)">修改本金</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'
import { get, post, del, put } from '@/api/index'
import addApi from '@/views/api/Add-api.vue'
import apiChart from '@/views/api/Api-chart.vue'

export default {
    data() {
        return {
            initStatus: false,
        }
    },
    components: {
        addApi,
        apiChart
    },
    props: {
        apiData: Object,
    },
    mounted() {

    },
    computed: {
        ...mapState([
            'token'
        ])
    },
    methods: {
        ...mapActions([
            'getBourseList',
            // 'getApiList'
        ]),

        // API 配置
        showConfig(apiId) {
            this.$emit('showApiInfo', apiId);
        },

        showAssetTemplate(apiId) {
            this.$emit('showAssetTemplate', apiId);
        },

        // 删除 Api
        deleteApi(apiId) {
            this.$confirm('是否删除此API?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var url = this.$baseUrl + '/api/delete';
                var param = {
                    'token': this.token,
                    'apiId': apiId
                };
                del(url, param).then(resp => {
                    if (resp.code == 200) {
                        this.$notify.info({
                            message: '删除成功',
                            title: '提示',
                            offset: 100
                        })
                        this.getApiList();
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100
                        })
                    }
                })
            }).catch(() => {
                // 取消后的操作
            })

        },

        // 基本配置
        showBaseConfig(apiId) {
            this.$emit('showBaseApiInfo', apiId);
        },

        // 刷新收益曲线
        fleshCurve(apiId) {
            let url = this.$baseUrl + "/api/clear";
            let formData = new FormData();
            formData.append('token', this.token);
            formData.append('apiId', apiId);
            put(url, formData).then(resp => {
                console.log(resp)
                if (resp.code == 200) {
                    this.$notify.info({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        // 资产初始化
        initAsset(apiId) {
            this.$confirm("是否设置持仓模式为全仓和杠杆倍数为10倍", "提示", {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let url = this.$baseUrl + '/api/init';
                let formData = new FormData();
                formData.append("token", this.token);
                formData.append("apiId", apiId);
                this.initStatus = true;
                put(url, formData).then(resp => {

                    if (resp.code == 200) {
                        this.$notify.info({
                            message: '初始化成功',
                            title: '提示',
                            offset: 100,
                            duration: 1000
                        })
                        this.initStatus = false;
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: "提示",
                            offset: 100,
                            duration: 1000
                        })
                        this.initStatus = false;
                    }
                })
            }).catch(() => {

            })
        },

        // 高级设置
        advanceSetting(apiId) {
            this.$emit('advanceSetting', apiId)
        }
    }
}
</script>

<style lang="scss">
.api-info{
    margin: 0 !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    background-color: #2A2D2E;
    border-bottom: 1px solid #353434;
    .api-info-item{
        padding: 5px;
        flex: 1;
        .el-dropdown{
            span{
                padding: 3px;
                background-color: #262829;
            }
        }
        .el-dropdown:hover{
            cursor: pointer;
            span{
                color:#787979;
            }
        }
    }
    .dialog-header{
        padding: 20px 0;
        border-bottom: 1px solid #787979;
    }
}
.api-info:hover{
    background-color: #212223;
}
</style>
